import { Form, Input } from "antd";
import { useTranslation } from "react-i18next";

const BillingName = () => {
  const { t } = useTranslation();
  return (
    <Form.Item
      name="billing_name"
      label={t("billing.billingNameLabel")}
      rules={[
        { min: 3, message: t("billing.billingNameMin") },
        { max: 60, message: t("billing.billingNameMax") },
        { required: true, message: t("billing.billingNameRequired") },
      ]}
      hasFeedback
    >
      <Input placeholder={t("billing.billingNamePlaceholder")} />
    </Form.Item>
  );
};

export default BillingName;
